/**
 * ****************************************************************************
 * @description     :   Route for bb app
 * @created at      :   2023/02/23
 * @created by      :   ANS873 – baonx@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const ba001000i = () => import('@/views/ba/ba001000i');
const ba001000l = () => import('@/views/ba/ba001000l');
/**
 * Defined Router
 */
export default [
    {
        path: '/ba/ba001000i',
        name: 'Ba001000i',
        component: ba001000i,
        meta: {
            title: '日報入力',
            layout: 'MainLayout'
        }
    },
    {
        path: '/ba/ba001000l',
        name: 'Ba001000l',
        component: ba001000l,
        meta: {
            title: '現場シフト一覧',
            layout: 'MainLayout'
        }
    }
];
